export default __webpack_public_path__ + "static/media/feature-icon-06.4c5a0c9b.svg";